<template>
  <b-card
    class="card-congratulation-medal"
  >
    <h5 v-if="title">
      {{ title }}
    </h5>
    <b-card-text
      v-if="text"
      class="font-small-3"
    >
      {{ text }}
    </b-card-text>
    <h3>
      <span
        class="mb-75 mt-2 pt-50 text-secondary mr-1"
        style="text-decoration: line-through;"
      >{{ price }}</span>
      <span class="mb-75 mt-2 pt-50 text-primary">{{ salePrice }}</span>
      <small>{{ priceSuffix }}</small>
    </h3>
    <b-button
      v-if="button"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="onButtonClick(button)"
    >
      {{ button.label }}
    </b-button>
    <b-img
      :src="require('@/assets/images/illustration/shop_launch/2d.png')"
      class="congratulation-medal d-none d-sm-block"
      alt=""
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'
import { usePurchaseCart } from '@/views/models/purchases/usePurchaseCart'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    button: {
      type: Object,
      default: null,
    },
    price: {
      type: String,
      default: null,
    },
    salePrice: {
      type: String,
      default: null,
    },
    priceSuffix: {
      type: String,
      default: null,
    },
  },
  methods: {
    kFormatter,
    onButtonClick: config => {
      if (config.action === 'purchase') {
        const { buyNow } = usePurchaseCart()
        buyNow(config.purchasable)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.congratulation-medal {
  height: 100%;
}
</style>
